export const environment = {
  production: false,
  server_url:"https://vendingapp.oasisproducts.ng/api",
  login_url:'https://vendingapp.oasisproducts.ng/api',
  notification_ws_url: 'wss://vendingapp.oasisproducts.ng/api/notifications/ws',
};
